var map = {
	"./background/frikadeller.svg": 3206,
	"./background/karry.svg": 5587,
	"./background/kitchen.svg": 6448,
	"./background/lasagne.svg": 8890,
	"./background/overlay.svg": 3005,
	"./background/plate.svg": 323,
	"./background/table.svg": 4610,
	"./dialogueArrowDown.svg": 3233,
	"./dialogueArrowLeft.svg": 5761,
	"./dialogueArrowRight.svg": 8042,
	"./icons/icon-arrow-2.svg": 3650,
	"./icons/icon-arrow.svg": 941,
	"./icons/icon-back.svg": 1972,
	"./icons/icon-badgeCo2.svg": 6585,
	"./icons/icon-badgePrice.svg": 1000,
	"./icons/icon-badgeTaste.svg": 2460,
	"./icons/icon-cheap.svg": 2224,
	"./icons/icon-check.svg": 9598,
	"./icons/icon-check2.svg": 8324,
	"./icons/icon-climate.svg": 7410,
	"./icons/icon-close.svg": 84,
	"./icons/icon-continue.svg": 3251,
	"./icons/icon-cookie.svg": 4857,
	"./icons/icon-cross.svg": 1146,
	"./icons/icon-curry.svg": 6523,
	"./icons/icon-i.svg": 5680,
	"./icons/icon-info-2.svg": 984,
	"./icons/icon-info-3.svg": 7777,
	"./icons/icon-info.svg": 8579,
	"./icons/icon-lasagna.svg": 6021,
	"./icons/icon-loading.svg": 2854,
	"./icons/icon-meatballs.svg": 9600,
	"./icons/icon-smiley-glad.svg": 3840,
	"./icons/icon-smiley-gladdest.svg": 5985,
	"./icons/icon-smiley-sad.svg": 354,
	"./icons/icon-smiley-saddest.svg": 5502,
	"./icons/icon-smiley.svg": 2830,
	"./icons/icon-tasty.svg": 5645,
	"./ingredients/extras/cottageCheese.svg": 7623,
	"./ingredients/extras/mangoChutney.svg": 5721,
	"./ingredients/extras/pickledAsier.svg": 728,
	"./ingredients/extras/pickledLingonberries.svg": 3075,
	"./ingredients/extras/pumpkinMarmalade.svg": 2139,
	"./ingredients/greens/bananaSalat.svg": 9775,
	"./ingredients/greens/butterBrusselSprouts.svg": 6977,
	"./ingredients/greens/cucumberSalat.svg": 8770,
	"./ingredients/greens/friedMushrooms.svg": 1531,
	"./ingredients/greens/haricotSteamed.svg": 8498,
	"./ingredients/greens/ovenbakedCarrots.svg": 644,
	"./ingredients/greens/pickledRedCabbage.svg": 8366,
	"./ingredients/greens/rawCarrotNutSalat.svg": 7758,
	"./ingredients/greens/romaneSteamed.svg": 8142,
	"./ingredients/greens/winterkaleApple.svg": 8766,
	"./ingredients/meatballs/choppedChicken.svg": 7830,
	"./ingredients/meatballs/choppedCow.svg": 783,
	"./ingredients/meatballs/choppedFish.svg": 8797,
	"./ingredients/meatballs/choppedLamb.svg": 1700,
	"./ingredients/meatballs/choppedPig.svg": 4502,
	"./ingredients/meatballs/choppedPigBeans.svg": 7225,
	"./ingredients/meatballs/choppedPigPeas.svg": 8651,
	"./ingredients/meatballs/choppedQuinoaChickpea.svg": 2051,
	"./ingredients/nothing.svg": 9047,
	"./ingredients/plates/aubergineSlices.svg": 6906,
	"./ingredients/plates/cauliflowerSlices.svg": 2838,
	"./ingredients/plates/lasagnaPlates.svg": 2947,
	"./ingredients/plates/lasagnaPlatesWholeGrain.svg": 8377,
	"./ingredients/plates/potatoSlices.svg": 6517,
	"./ingredients/plates/roastedMushrooms.svg": 5413,
	"./ingredients/sauce/remouladeSauce.svg": 9361,
	"./ingredients/sauce/sennepCreme.svg": 1359,
	"./ingredients/sauce/skysauce.svg": 7167,
	"./ingredients/sauce/stewedCabbageSpinach.svg": 4264,
	"./ingredients/sauce/tomatoSauceParmasan.svg": 23,
	"./ingredients/sides/beanpasta-screws.svg": 5953,
	"./ingredients/sides/butterRiceApricot.svg": 8462,
	"./ingredients/sides/eggnoodles.svg": 8727,
	"./ingredients/sides/lenses-kale.svg": 9032,
	"./ingredients/sides/mintyoghurtAlmondsCucumberTomato.svg": 470,
	"./ingredients/sides/pasta-strips.svg": 7174,
	"./ingredients/sides/potato-boiled.svg": 5748,
	"./ingredients/sides/potatoboats.svg": 7745,
	"./ingredients/sides/rice-parboiled.svg": 3360,
	"./ingredients/sides/riceBrown.svg": 3673,
	"./ingredients/sides/spicyTomatoSalat.svg": 5812,
	"./ingredients/stew/bologneseBechamelCow.svg": 5303,
	"./ingredients/stew/bologneseBechamelSquashCow.svg": 8671,
	"./ingredients/stew/bolognesePeaProtein.svg": 729,
	"./ingredients/stew/cabbageBaconApple.svg": 6812,
	"./ingredients/stew/chickenCurry.svg": 9399,
	"./ingredients/stew/codSpinachTomatosauce.svg": 6942,
	"./ingredients/stew/curryChickpeaCauliflowerPig.svg": 3606,
	"./ingredients/stew/curryPeaCauliflower.svg": 7163,
	"./ingredients/stew/daalGreenLenses.svg": 44,
	"./ingredients/stew/fishCurryCoconutSauce.svg": 9969,
	"./ingredients/stew/tomatosauceVeganCheese.svg": 1802,
	"./ingredients/stew/tomatosauceVeggieBechamel.svg": 9020,
	"./ingredients/toppings/coconutFlakes.svg": 3497,
	"./ingredients/toppings/dryMango.svg": 7268,
	"./ingredients/toppings/freshBanana.svg": 1263,
	"./ingredients/toppings/honeyroastedSunflowerseeds.svg": 300,
	"./ingredients/toppings/mozarella.svg": 4500,
	"./ingredients/toppings/nutcrunchSage.svg": 4251,
	"./ingredients/toppings/parmesanCheeseGrated.svg": 8257,
	"./ingredients/toppings/peanuts.svg": 7812,
	"./ingredients/toppings/raisins.svg": 8097,
	"./logos/logo-absalon.svg": 6430,
	"./logos/logo-gamelab.svg": 9526,
	"./logos/logo.svg": 3183,
	"./pdf-images/badgeCo2.png": 7580,
	"./pdf-images/badgeCo2Fail.png": 616,
	"./pdf-images/badgePrice.png": 9444,
	"./pdf-images/badgePriceFail.png": 7376,
	"./pdf-images/badgeTaste.png": 7485,
	"./pdf-images/badgeTasteFail.png": 5229,
	"./pdf-images/smiley-glad.png": 969,
	"./pdf-images/smiley-gladdest.png": 342,
	"./pdf-images/smiley-sad.png": 4975,
	"./pdf-images/smiley-saddest.png": 8649,
	"./pdf-images/smiley.png": 530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;